(() => {
  if (customElements.get('bd-product-facts-pilot')) return;
  customElements.define('bd-product-facts-pilot', class extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.data = JSON.parse(this.querySelector('[data-bd-facts-config]').textContent);
      this.variantChanged = (event) => {
        if (event.target.matches('input[name="id"]')) this.update(event.target.value);
      };
      this.info?.addEventListener('change', this.variantChanged);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.offOption = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({data}) => {
          if (data?.event?.target && this.info?.contains(data.event.target)) this.update(null);
        });
        this.offVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data?.sectionId) === String(this.info?.dataset.originalSection || this.info?.dataset.section)) this.update(data?.variant?.id);
        });
      }
      this.update(this.data.selected);
    }
    disconnectedCallback() {
      this.offOption?.(); this.offVariant?.();
      this.info?.removeEventListener('change', this.variantChanged);
    }
    update(id) {
      const variant = this.data.variants[String(id)];
      this.dataset.selectedVariant = variant ? String(id) : '';
      this.querySelector('[data-bd-size]').textContent = variant?.size || this.data.pending;
      this.querySelectorAll('[data-bd-sku]').forEach(e => {e.textContent = variant?.sku || this.data.pending;});
      this.querySelector('[data-bd-enquiry-sku]').value = variant?.sku || '';
      this.querySelector('[data-bd-enquiry-size]').value = variant?.size || '';
      this.querySelector('[data-bd-enquiry-variant]').value = variant ? String(id) : '';
      const page = new URL(location.pathname, location.origin);
      if (variant) page.searchParams.set('variant', String(id));
      this.querySelector('[data-bd-enquiry-url]').value = page.href;
      const returnPage = new URL(page.href);
      returnPage.searchParams.set('contact_posted', 'true');
      returnPage.hash = this.querySelector('form').id;
      this.querySelector('input[name="return_to"]').value = variant
        ? returnPage.pathname + returnPage.search + returnPage.hash : '';
      this.querySelector('[data-bd-enquiry-send]').disabled = !variant;
      this.querySelector('[data-bd-selection-status]').textContent = variant ? '' : this.data.pending;
    }
  });
})();
